import { ref } from 'vue';
import { uniqueId } from 'lodash-es';

import type { PassengerChildrenMap } from '@entities/passengers-state';

export const usePassengerChildren = (
  initialChildren?: PassengerChildrenMap,
) => {
  const children = ref<PassengerChildrenMap>(
    new Map(initialChildren) ?? new Map(),
  );

  const addChild = () => {
    children.value.set(uniqueId('_passenger-child'), { isEditing: true });
  };

  const deleteChild = (childId: string) => {
    children.value.delete(childId);
  };

  const toggleEditingState = (childId: string) => {
    const child = children.value.get(childId);

    if (child?.age === undefined) {
      deleteChild(childId);
      return;
    }

    children.value.set(childId, {
      age: child.age,
      isEditing: !child.isEditing,
    });
  };

  const setChildAge = (childId: string, age: number) => {
    children.value.set(childId, { age, isEditing: false });
  };

  return {
    children,
    addChild,
    deleteChild,
    toggleEditingState,
    setChildAge,
  };
};
